/*
 * Standalone header runtime (self-hosted) for the
 * header only (theme already ships its own assets/header.js, untouched).
 * Reproduces, with no third-party dependency:
 *   - cart button  -> opens the theme's <cart-drawer id="CartDrawer">
 *   - Produkty / O nás dropdowns (hover on desktop, click/tap everywhere,
 *     outside-click + Escape close) via [data-state] on .hdr-dropdown--wrapper
 *   - mobile menu (open-overlay) via [data-state] on .hdr-overlay
 *   - country/language selector (country_code) -> POST /localization
 * The generated CSS keys off [data-state=open|closed] and
 * [data-hdr-state=active|inactive], so we just toggle those.
 */
(function () {
  'use strict';

  var HOVER_CLOSE_DELAY = 160;
  var HOVER_OPEN_DELAY = 140;

  // ------------------------------------------------------------------ cart
  document.addEventListener(
    'click',
    function (e) {
      var t = e.target.closest('[data-hdr-action="open-cart"], a[aria-controls="CartDrawer"]');
      if (!t) return;
      var drawer = document.getElementById('CartDrawer');
      if (drawer && typeof drawer.show === 'function') {
        e.preventDefault();
        e.stopImmediatePropagation();
        drawer.show();
      }
    },
    true
  );

  // ---------------------------------------------------------------- search
  // Search icon opens the theme's <search-drawer id="SearchDrawer"> (same
  // drawer framework as the cart). Falls back to the search page href w/o JS.
  document.addEventListener(
    'click',
    function (e) {
      var t = e.target.closest('[data-hdr-action="open-search"], a[aria-controls="SearchDrawer"]');
      if (!t) return;
      var drawer = document.getElementById('SearchDrawer');
      if (drawer && typeof drawer.show === 'function') {
        e.preventDefault();
        e.stopImmediatePropagation();
        drawer.show(t);
      }
    },
    true
  );

  // ------------------------------------------------------ dropdowns/overlays
  var entriesById = {};
  var openEntries = [];

  function hostFor(panel) {
    return panel.closest('.hdr-dropdown--wrapper, .hdr-overlay') || panel;
  }

  // The generated CSS only pins the dropdown wrapper to position:fixed 0,0 — its JS
  // computed the real spot from the trigger. Reproduce that using the wrapper's
  // data-hdr-dropdown-placement / -offset. Overlays are full-screen: skip.
  function positionHost(entry) {
    var host = entry.host;
    if (!host || !host.classList.contains('hdr-dropdown--wrapper')) return;
    var trigger = entry.triggers[0];
    if (!trigger) return;
    // The placement/offset attrs live on the wrapper OR (as generated) on its
    // inner panel — read from whichever has them.
    var pel = host.hasAttribute('data-hdr-dropdown-placement')
      ? host
      : host.querySelector('[data-hdr-dropdown-placement]');
    var placement = (pel && pel.getAttribute('data-hdr-dropdown-placement')) || 'bottom-start';
    var offset = (pel && parseFloat(pel.getAttribute('data-hdr-dropdown-offset'))) || 0;
    var tr = trigger.getBoundingClientRect();
    host.style.top = Math.round(tr.bottom + offset) + 'px';

    // Full-width mega menu: placement exactly 'bottom' / 'top' spans the whole
    // viewport (the inner panel stretches to it). Anchored dropdowns
    // (bottom-start / -end …) compute a left under their trigger.
    if (placement === 'bottom' || placement === 'top') {
      host.style.left = '0px';
      host.style.right = '0px';
      host.style.width = '';
      if (pel && pel !== host) { pel.style.width = '100%'; pel.style.maxWidth = 'none'; }
      return;
    }
    if (pel && pel !== host) { pel.style.width = ''; pel.style.maxWidth = ''; }
    host.style.right = '';
    host.style.width = '';
    var hw = host.offsetWidth;
    var vw = document.documentElement.clientWidth;
    var margin = 8;
    var left;
    if (placement.indexOf('start') > -1) left = tr.left;
    else if (placement.indexOf('end') > -1) left = tr.right - hw;
    else left = tr.left + tr.width / 2 - hw / 2;
    if (left + hw > vw - margin) left = vw - margin - hw;
    if (left < margin) left = margin;
    host.style.left = Math.round(left) + 'px';
  }

  function repositionOpen() {
    openEntries.forEach(positionHost);
  }

  function getEntry(id) {
    if (entriesById[id]) return entriesById[id];
    var panel = document.querySelector('[data-hdr-panel="' + id + '"]');
    if (!panel) return null;
    var entry = {
      id: id,
      host: hostFor(panel),
      triggers: Array.prototype.slice.call(document.querySelectorAll('[data-hdr-id="' + id + '"]')),
      open: false,
      closeTimer: null,
    };
    entriesById[id] = entry;
    return entry;
  }

  function apply(entry, isOpen) {
    entry.open = isOpen;
    entry.host.setAttribute('data-state', isOpen ? 'open' : 'closed');
    entry.triggers.forEach(function (tr) {
      tr.setAttribute('data-hdr-state', isOpen ? 'active' : 'inactive');
      tr.querySelectorAll('[data-hdr-state]').forEach(function (n) {
        n.setAttribute('data-hdr-state', isOpen ? 'active' : 'inactive');
      });
    });
  }

  function openEntry(entry) {
    if (entry.closeTimer) { clearTimeout(entry.closeTimer); entry.closeTimer = null; }
    if (entry.open) return;
    apply(entry, true);
    if (openEntries.indexOf(entry) < 0) openEntries.push(entry);
    positionHost(entry);
  }

  function closeEntry(entry) {
    if (!entry.open) return;
    apply(entry, false);
    openEntries = openEntries.filter(function (x) { return x !== entry; });
  }

  function closeAll(except) {
    openEntries.slice().forEach(function (e) { if (e !== except) closeEntry(e); });
  }

  function bindTrigger(triggerEl) {
    var id = triggerEl.getAttribute("data-hdr-id");
    if (!id) return;
    var entry = getEntry(id);
    if (!entry) return;

    triggerEl.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (entry.open) closeEntry(entry);
      else { closeAll(entry); openEntry(entry); }
    });

    var onHover = triggerEl.hasAttribute('data-hdr-hover');
    if (onHover && window.matchMedia && window.matchMedia('(hover: hover)').matches) {
      var openTimer = null;
      var cancelOpen = function () { if (openTimer) { clearTimeout(openTimer); openTimer = null; } };
      var schedule = function () {
        cancelOpen();
        if (entry.closeTimer) clearTimeout(entry.closeTimer);
        entry.closeTimer = setTimeout(function () { closeEntry(entry); }, HOVER_CLOSE_DELAY);
      };
      // Hover-intent: only open after a short dwell. Sweeping the mouse across
      // the navbar (e.g. toward the icons) then no longer flash-opens the panel
      // — which used to paint the megamenu's white background for a frame.
      triggerEl.addEventListener('mouseenter', function () {
        if (entry.closeTimer) { clearTimeout(entry.closeTimer); entry.closeTimer = null; }
        cancelOpen();
        openTimer = setTimeout(function () { closeAll(entry); openEntry(entry); }, HOVER_OPEN_DELAY);
      });
      triggerEl.addEventListener('mouseleave', schedule);
      entry.host.addEventListener('mouseenter', function () {
        cancelOpen();
        if (entry.closeTimer) { clearTimeout(entry.closeTimer); entry.closeTimer = null; }
      });
      entry.host.addEventListener('mouseleave', schedule);
    }
  }

  document.addEventListener('click', function (e) {
    if (!openEntries.length) return;
    var inside = openEntries.some(function (entry) {
      return entry.host.contains(e.target) || entry.triggers.some(function (t) { return t.contains(e.target); });
    });
    if (!inside) closeAll();
  });
  document.addEventListener('keyup', function (e) {
    if (e.key === 'Escape' || e.keyCode === 27) closeAll();
  });

  // -------------------------------------------------------------- localization
  function bindLocalization() {
    document
      .querySelectorAll('.hdr-localization-select select[name="localization-select--country"]')
      .forEach(function (select) {
        select.addEventListener('change', function () {
          var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
          var form = document.createElement('form');
          form.method = 'POST';
          form.action = root + 'localization';
          // Shopify's /localization endpoint requires a multipart/form-data POST
          // (that's what {% form 'localization' %} emits). A urlencoded POST 404s.
          form.enctype = 'multipart/form-data';
          form.acceptCharset = 'UTF-8';
          form.style.display = 'none';
          function hidden(name, value) {
            var i = document.createElement('input');
            i.type = 'hidden';
            i.name = name;
            i.value = value;
            form.appendChild(i);
          }
          // return_to must be a clean same-origin path; Shopify rejects a
          // return_to carrying preview/editor params (preview_theme_id, _ab,
          // _fd, _sc...) and then renders the raw /localization page instead of
          // redirecting back. Strip those so the switch lands back on the page.
          var returnTo;
          try {
            var u = new URL(window.location.href);
            ['preview_theme_id', '_ab', '_fd', '_sc', '_ppp'].forEach(function (k) {
              u.searchParams.delete(k);
            });
            returnTo = u.pathname + u.search + u.hash;
          } catch (e) {
            returnTo = window.location.pathname;
          }
          // Shopify's {% form 'localization' %} always emits form_type + utf8;
          // without form_type=localization the endpoint doesn't process the
          // switch and just renders the raw /localization page.
          hidden('form_type', 'localization');
          hidden('utf8', '\u2713');
          // /localization is a PUT route; Shopify's form uses the _method
          // override. Without _method=put the POST 404s.
          hidden('_method', 'put');
          hidden('country_code', select.value);
          hidden('return_to', returnTo);
          document.body.appendChild(form);
          form.submit();
        });
      });
  }

  // ------------------------------------------------------ data-hdr-href nav
  // Some megamenu cards ("Produkty" row 2 + the "all products" link) are <form>
  // / <div> wrappers that carry the destination in data-hdr-href instead of an
  // <a href> (they carry the URL in data-hdr-href). Bind a click -> navigate so
  // every card is clickable, while leaving real inner links/buttons alone.
  function bindHrefTargets() {
    document.querySelectorAll('[data-hdr-href]').forEach(function (el) {
      if (el.__lvHref) return;
      el.__lvHref = true;
      el.style.cursor = 'pointer';
      el.addEventListener('click', function (e) {
        if (e.target.closest('a[href], button')) return;
        var href = el.getAttribute('data-hdr-href');
        if (href) window.location.href = href;
      });
    });
  }

  // ------------------------------------------------------------- ribbon ticker
  // Seamless CSS marquee for the top ribbon (.hdr-ticker-container). Self-hosted
  // here so the header has no external runtime dependency. Per-element guarded.
  var marqueeInjected = false;
  function bindTickers() {
    document.querySelectorAll('.hdr-ticker-container').forEach(function (container) {
      if (container.__lvTicker) return;
      container.__lvTicker = true;
      var ticker = container.querySelector('.hdr-ticker');
      var unit = ticker && ticker.querySelector('.hdr-ticker-initial-child-container');
      if (!ticker || !unit) return;
      if (!marqueeInjected) {
        var st = document.createElement('style');
        st.textContent = '@keyframes hdrMarquee{from{transform:translateX(0)}to{transform:translateX(-50%)}}';
        document.head.appendChild(st);
        marqueeInjected = true;
      }
      ticker.style.display = 'flex';
      ticker.style.flexWrap = 'nowrap';
      ticker.style.willChange = 'transform';
      // Fill: repeat the unit so ONE half of the track is >= the container
      // width, then mirror it (even copies). The -50% keyframe then moves
      // exactly one half -> seamless, gap-free loop at any viewport width.
      var uw = unit.scrollWidth || unit.offsetWidth || 1;
      var cw = container.clientWidth || uw;
      var half = Math.max(1, Math.ceil(cw / uw));
      for (var k = 1; k < half * 2; k++) ticker.appendChild(unit.cloneNode(true));
      var speed = parseFloat(container.getAttribute('data-hdr-ticker-speed') || '50') || 50;
      var reversed = container.getAttribute('data-hdr-ticker-is-reversed') === 'true';
      var pauseHover = container.getAttribute('data-hdr-ticker-pause') === 'true';
      var dur = Math.max(5, Math.round((uw * half) / speed));
      ticker.style.animation = 'hdrMarquee ' + dur + 's linear infinite';
      if (reversed) ticker.style.animationDirection = 'reverse';
      if (pauseHover) {
        container.addEventListener('mouseenter', function () { ticker.style.animationPlayState = 'paused'; });
        container.addEventListener('mouseleave', function () { ticker.style.animationPlayState = 'running'; });
      }
    });
  }

  // ------------------------------------------------------------- cart count
  // The server renders .hdr-nav__cart-count once. Keep it live by re-reading
  // /cart.js whenever the cart changes (quick-cart/free-gift dispatch these),
  // mirroring the Liquid rule that skips hidden gift lines (_hdr-hidden).
  function updateCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var n = 0;
        (cart.items || []).forEach(function (it) {
          var p = it.properties || {};
          if (p['_hdr-hidden'] === 'true' || p['_hdr-hidden'] === true) return;
          n += it.quantity;
        });
        document.querySelectorAll('.hdr-nav__cart-count').forEach(function (el) {
          el.textContent = n >= 100 ? '99+' : (n > 0 ? String(n) : '');
          el.style.display = n > 0 ? '' : 'none';
        });
      })
      .catch(function () {});
  }
  function bindCartCount() {
    [
      'cart:updated', 'cart:refresh', 'cart:change', 'cart:build', 'cart:added',
      'ajaxProduct:added', 'variant:add', 'line-item:change', 'quick-cart:updated',
    ].forEach(function (ev) { document.addEventListener(ev, updateCartCount); });
    window.addEventListener('pageshow', function (e) { if (e.persisted) updateCartCount(); });
  }

  // ------------------------------------------------- mobile drawer accordion
  // The "Produkty" group in the mobile menu collapses/expands. CSS keys the
  // content height off [data-state=open] on .hdr-drawer__el7 (+ chevron rotate);
  // we just toggle it and seed a px height so it animates both ways.
  function bindDrawerAccordion() {
    document.querySelectorAll('.hdr-drawer [data-hdr-action="toggle-accordion"]').forEach(function (btn) {
      if (btn.__hdrAcc) return;
      btn.__hdrAcc = true;
      var item = btn.closest('.hdr-drawer__el7');
      if (!item) return;
      var content = item.querySelector('.hdr-drawer__el10');
      btn.setAttribute('aria-expanded', item.getAttribute('data-state') === 'open' ? 'true' : 'false');
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var open = item.getAttribute('data-state') === 'open';
        // Measure now (drawer is open) so the height transition has a px target.
        if (content) content.style.setProperty('--hdr-accordion-content-height', content.scrollHeight + 'px');
        if (open) {
          requestAnimationFrame(function () { item.setAttribute('data-state', 'closed'); });
        } else {
          item.setAttribute('data-state', 'open');
        }
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    });
  }

  // ------------------------------------------------- mobile collapsing topbar
  // The header is position:fixed, so on phones the cycling contact bar eats
  // ~40px of every screen. Collapse it once the page is scrolled past it and
  // bring it back at the top. CSS (header.css, <=768px) does the animation.
  function bindTopbarCollapse() {
    var topbar = document.getElementById('hdr-topbar');
    var bar = topbar && topbar.querySelector('.hdr-topbar__bar');
    if (!bar) return;

    var hidden = false;
    var barHeight = 40;
    var ticking = false;

    function apply() {
      ticking = false;
      // Math.max: never sample the bar mid-collapse-animation — a shrunken
      // reading would lower the threshold and make the toggle flap near the top.
      if (!hidden && bar.offsetHeight) barHeight = Math.max(barHeight, bar.offsetHeight);
      // Threshold = the bar's own height: below it the header's in-flow spacer
      // still covers the fixed header, so collapsing there would leave a gap.
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      var next = y > barHeight;
      if (next === hidden) return;
      hidden = next;
      topbar.setAttribute('data-hdr-topbar', hidden ? 'hidden' : 'shown');
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(apply);
    }

    topbar.setAttribute('data-hdr-topbar', 'shown');
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();
  }

  // ---------------------------------------------------------------------- init
  function init() {
    bindCartCount();
    bindDrawerAccordion();
    bindTopbarCollapse();
    document
      .querySelectorAll(
        '[data-hdr-action="open-dropdown"][data-hdr-id],' +
          '[data-hdr-action="open-overlay"][data-hdr-id]'
      )
      .forEach(bindTrigger);
    bindHrefTargets();
    bindTickers();
    bindLocalization();
    window.addEventListener('resize', repositionOpen);
    window.addEventListener('scroll', repositionOpen, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
